/**
 * Resolve studio logo URL from API response (field names vary by endpoint).
 *
 * Order mirrors resolveStudioLogo on the backend: the uploaded `logo` is the
 * studio's actual mark, whitelabel partners supply theirs via whitelabelConfig,
 * and only then do we fall back to a cover photo, which is a room shot rather
 * than a brand.
 */
export function resolveStudioLogoUrl(studio: any): string {
  if (!studio) return '';
  return (
    studio.logo
    || studio.whitelabelConfig?.logoUrl
    || studio.images?.[0]
    || studio.image
    || ''
  );
}
